import {
  Component,
  ViewChild,
  ViewChildren,
  AfterViewInit,
  QueryList,
} from "@angular/core";
import { VideoComponent } from "../video/video.component";

@Component({
  selector: "app-help",
  templateUrl: "./help.component.html",
  styleUrls: ["./help.component.scss"],
})
export class HelpComponent implements AfterViewInit {
  singleVideos: VideoComponent[] = [];
  private introVideo: string= "https://www.interaction-room.de/iris-videos/einfuehrung_volle_laenge.mp4";
  private videoUrls = [
    {
      url: "https://www.interaction-room.de/iris-videos/1_Einleitung.mp4",
      title: "Erstellen und Importieren von Projekten"
    },
    {
      url: "https://www.interaction-room.de/iris-videos/2_Fragebögen.mp4",
      title: "Fragebögen erstellen und versenden"
    },
    {
      url: "https://www.interaction-room.de/iris-videos/3_Epics.mp4",
      title: "Epics erstellen, bearbeiten und einsehen"
    },
    {
      url: "https://www.interaction-room.de/iris-videos/schaetzen.mp4",
      title: "Schätzen von Items"
    },
    {
      url: "https://www.interaction-room.de/iris-videos/4_Sprints.mp4",
      title: "Sprints erstellen, bearbeiten und starten"
    },
    {
      url: "https://www.interaction-room.de/iris-videos/5_Annotationen.mp4",
      title: "Annotationen erstellen und Nutzen schätzen"
    },
    {
      url: "https://www.interaction-room.de/iris-videos/6_Retrospektiven.mp4",
      title: "Retrospektiven erstellen, bearbeiten und starten"
    } 
  ];

  @ViewChildren("singleVideos") singleVideoRefs: QueryList<VideoComponent>;

  //Loads the ViewChildren and converts them to an Array
  ngAfterViewInit() {
    this.singleVideos = this.singleVideoRefs.toArray();
  }

  pauseAllVideos() {
    // onCloseCallback changes this, so its saved in ref instead.
    let ref = this;
    return () => {
      for (let video of ref.singleVideos) {
        video.pauseVideo();
      }
    };
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/help/help.component.ts